module.exports = __webpack_public_path__ + "static/media/green-l.79b1c670.svg";